import React from 'react';
import { Switch } from 'antd';
import ZoomBtn from './ZoomBtn';
import PanningConfig from './PanningConfig';

const GraphContainer = ({ cy }) => {
  function onClickToggleButton() {
    $('#graphControlPanel').toggleClass('fixed');
    $('#cy-wrapper').toggleClass('large');
  }

  return (
    <div id="cy-wrapper" className="col-lg-8 col-xs-12">
      <PanningConfig cy={cy} />
      <Switch
        id={`toggle-${Date.now()}`}
        size="large"
        defaultChecked={false}
        className="switch"
        onClick={onClickToggleButton}
      />

      {/* render cy in cy-container: */}
      <div id="cy-container" />
      <ZoomBtn cy={cy} />
    </div>
  );
};

export default GraphContainer;
